import { IRequisitionState } from '@/store/requisition';
import { IRequisitionGetters } from './getters.types';
import {
  IRequisition,
  Requisition,
  IUser,
  User,
  RequisitionComment,
  IRequisitionComment
} from '@/models';
import { Transition } from '@/models/transition';

export const getters: IRequisitionGetters = {
  getRequisitionCount(state: IRequisitionState): number {
    return state.count;
  },

  getRequisitions(state: IRequisitionState): IRequisition[] {
    return state.requisitions.map(data => new Requisition(data));
  },

  getRequisitionById: (state: IRequisitionState) => (
    id: number
  ): IRequisition | undefined => {
    const data = state.requisitions.find(requisition => requisition.id === id);
    if (!data) {
      return undefined;
    }

    return new Requisition(data);
  },

  getRequisitionApprovers: (state: IRequisitionState): IUser[] => {
    return state.approvers.map(data => new User(data));
  },

  getRequisitionBuyers: (state: IRequisitionState): IUser[] => {
    return state.buyers.map(data => new User(data));
  },

  getRequisitionActivities: (state: IRequisitionState): Transition[] => {
    return state.activities;
  },

  getRequisitionComments: (state: IRequisitionState): RequisitionComment[] => {
    return state.comments.map(data => new RequisitionComment(data));
  },

  getRequisitionCommentById: (state: IRequisitionState) => (
    id: number
  ): IRequisitionComment | undefined => {
    const data = state.comments.find(requisition => requisition.id === id);
    if (!data) {
      return undefined;
    }

    return new RequisitionComment(data);
  },

  getLastCreatedRequisitionId: (state: IRequisitionState): null | number => {
    return state.lastCreatedRequisitionId;
  },

  getLastCreatedRequisitionCommentId: (
    state: IRequisitionState
  ): null | number => {
    return state.lastCreatedRequisitionCommentId;
  },

  getRequisitionMentionableUsers(state: IRequisitionState): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
